import { actionConstants } from '../constants';
import {
  successReqActionType,
  failReqActionType,
  startReqActionType
} from 'helper/requestHelper';

const initialState = {
  paginatedEvents: [],
  lastEvaluatedKeys: null,
  totalCount: 0,
  eventDetail: null,

  isLoadingEventsList: false,
  isLoadingEvent: false
};

const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case startReqActionType(actionConstants.PAGINATED_LIST_EVENTS):
      return {
        ...state,
        isLoadingEventsList: true
      };

    case successReqActionType(actionConstants.PAGINATED_LIST_EVENTS):
      return {
        ...state,
        isLoadingEventsList: false,
        paginatedEvents: action.payload.reset
          ? action.payload.data || []
          : [...state.paginatedEvents, ...(action.payload.data || [])],
        lastEvaluatedKeys: action.payload.last_evaluated_key,
        totalCount: action.payload.reset
          ? action.payload.total_count ??
            (action.payload.data || []).length
          : state.totalCount
      };

    case failReqActionType(actionConstants.PAGINATED_LIST_EVENTS):
      return {
        ...state,
        isLoadingEventsList: false
      };

    case startReqActionType(actionConstants.GET_EVENT_DETAIL):
      return {
        ...state,
        isLoadingEvent: true,
        eventDetail: null
      };

    case successReqActionType(actionConstants.GET_EVENT_DETAIL):
      return {
        ...state,
        eventDetail: action.payload,
        isLoadingEvent: false
      };

    case failReqActionType(actionConstants.GET_EVENT_DETAIL):
      return {
        ...state,
        isLoadingEvent: false
      };

    case successReqActionType(actionConstants.CREATE_EVENT):
      return {
        ...state,
        eventDetail: action.payload
      };

    case successReqActionType(actionConstants.UPDATE_EVENT):
      return {
        ...state,
        eventDetail: action.payload
      };

    case successReqActionType(actionConstants.DELETE_EVENT):
      return {
        ...state,
        paginatedEvents: state.paginatedEvents.filter(
          e => e.id !== action.payload.eventId
        ),
        eventDetail:
          state.eventDetail && state.eventDetail.id === action.payload.eventId
            ? null
            : state.eventDetail
      };

    default:
      return state;
  }
};

export default eventsReducer;
